import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'issue-field-epic-link.edit.placeholder',
		defaultMessage: 'Select Epic',
		description: '',
	},
	noOptionsMessage: {
		id: 'issue-field-epic-link.edit.no-options-message',
		defaultMessage: 'No matches found',
		description: 'Message when no options are found in a select',
	},
	failedFetch: {
		id: 'issue-field-epic-link.edit.failed-fetch',
		defaultMessage: 'Search failed. Please try again.',
		description: 'Message when fetching suggestions fails',
	},
	loadingMessage: {
		id: 'issue-field-epic-link.edit.loading-message',
		defaultMessage: 'Searching...',
		description: 'Message showed when options are being loaded from the server.',
	},
	allEpics: {
		id: 'issue-field-epic-link.edit.all-epics',
		defaultMessage: 'All epics',
		description: 'Label for the group containing all of the epics',
	},
});
